export const COURSE_BADGE_BESTSELLER = 'bestseller';
export const COURSE_BADGE_FREE = 'free';
export const COURSE_BADGE_HIGHEST_RATED = 'top_rated';
export const COURSE_BADGE_HOT_AND_NEW = 'hot_and_new';
export const COURSE_BADGE_NEW = 'new';
export const COURSE_BADGE_UPDATED_RECENTLY = 'updated_recently';
export const COURSE_BADGE_CODING_EXERCISES = 'coding_exercises';
export const COURSE_BADGE_PREMIUM = 'premium';
export const COURSE_BADGE_INCLUDED_IN_PLANS = 'included_in_plans';
export const COURSE_BADGE_TOP_PICK = 'top_pick';
export const COURSE_BADGE_ROLE_PLAY = 'role_play';
export const COURSE_BADGE_LABS = 'labs';
export const COURSE_BADGE_PRACTICE_TESTS = 'practice_tests';
export const COURSE_BADGE_HANDS_ON_LEARNING = 'hands_on_learning';
export const COURSE_BADGE_QUIZZES = 'quizzes';
export const COURSE_BADGE_WORKSPACES = 'workspaces';
export const COURSE_BADGE_GROW_WITH_GOOGLE = 'grow_with_google';
//# sourceMappingURL=constants.js.map